import { ConfigType } from './types';

const config: ConfigType = {
  ApiUrl: process.env.REACT_APP_API_ENDPOINT ?? '',
};

export default config;
